import React, { Component } from "react";
import BsySelect from "../BsySelect";
import BsyTableList from "../BsyTableList";
import BsyAlert from "../BsyAlert";
import './index.css';

export default class BsyApprovePane extends Component {


    constructor(props) {
        super(props);
        this.state = {
            // approve_type: props.approve_type,
            group_id: props.group_id,
            mode: props.mode,
            status: props.status,  //状态  0申请中 1已通过 2已拒绝 3全部
            hasCount: true,
            limit: 20,
            skip: 0,
            approves: {
                has_qr_modify: false,
                users: [],
                count: 0,
                not_joined: 0,
            },
            items: [
                {
                    text: React.language('all'),
                    value: 3,
                    selected: true
                },
                {
                    text: React.language('unprocessed'), //未处理
                    value: 0,
                    selected: false
                },
                {
                    text: React.language('pass'), //通过
                    value: 1,
                    selected: false
                }, {
                    text: React.language('refuse'), //拒绝
                    value: 2,
                    selected: false
                }
            ]
        }
    }
    componentDidMount() {
        this.get_approve_list();
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

        if (this.props.group_id != nextProps.group_id) {
            this.setState({
                groupList: nextProps.group_id,
                skip: 0,
            }, () => {
                this.get_approve_list();
            })
        }

    }

    get_approve_list = () => {
        const { group_id, limit, skip, status, mode } = this.state

        // selectGroup 为空的时候 查询所有数据 不传分组id给后端
        React.axios('/corp/apply_check_list', {
            group_id: group_id,
            mode: mode,
            limit: limit,
            status: status,
            _id:this.props._id,
            skip: skip * limit
        }).then(res => {

            const approves = {
                ...{
                    users: res.data.list,
                    count: res.data.count,
                }
            }

            this.setState({
                approves: approves
            })

        }).catch(res => {

        })
    }


    get_status_value = (e) => {
        // console.log('get_status_value', e)
        this.setState({
            status: e,
            skip: 0
        }, () => {
            this.get_approve_list();
        })
    }

    apply_check_approve = (e, data) => {
        ///corp/apply_check_approve
        const { mode } = this.state

        if (e == "delete") {
            BsyAlert({
                title: React.language("confirm.delete.the", {
                    name: data.username
                }),
                // msg: React.language("outsider.group.delete.tip"),
                type: "warning",
                text4Ok: React.language("delete"),
                OkType: "red",
                text4Cancel: React.language("cancel"),
                ok: () => {

                    React.axios('/corp/apply_check_approve', {
                        mode: mode, //模式 member成员  outsider 外部联系人 
                        operate: e,  //pass 通过  refuse拒绝
                        uid: data.uid,
                    }).then(res => {

                        this.get_approve_list();

                    }).catch(res => {

                    })
                }
            })
        } else {
            React.axios('/corp/apply_check_approve', {
                mode: mode, //模式 member成员  outsider 外部联系人 
                operate: e,  //pass 通过  refuse拒绝
                uid: data.uid,
            }).then(res => {

                this.get_approve_list();

            }).catch(res => {

            })
        }
    }

    skipChange = (val) => {
        this.setState({ skip: val }, () => {
            this.get_approve_list()
        })
    }

    listLimitChange = (val) => {
        this.setState({ limit: val }, () => {
            this.get_approve_list()
        })
    }

    listFilterChange = (val) => {
        this.setState({ filter: val }, () => {
            this.get_approve_list()
        })
    }


    render() {
        const { status, items, limit, skip, approves } = this.state;
        let that = this;
        const list = [{
            width: 150,
            key: "username",
            value: React.language("approve.list.header.1"),
        }, {
            width: 150,
            key: "mobile_email",
            value: React.language("approve.list.header.2"),
        }, {
            width: 150,
            key: "applytime",
            value: React.language("approve.list.header.3"),
        }, {
            width: 284,
            key: "reason",
            title: true,
            value: React.language("approve.list.header.4"),

        }, {
            width: 140,
            key: "again",
            value: "",
            cls: 'menu',
            onCellCreate:(config, data) => {
                return <> {
                    data.status == 0 ? <>
                        <span className="menu-itme delete" onClick={e => { that.apply_check_approve('delete', data) }} >{React.language('delete')}</span>
                        <span className="menu-itme refuse" onClick={e => { that.apply_check_approve('refuse', data) }} >{React.language('refuse')}</span>
                        <span className="menu-itme pass" onClick={e => { that.apply_check_approve('pass', data) }} >{React.language('pass')}</span>
                    </>
                        : data.status == 1 ? <>
                            <span className="menu-itme delete" onClick={e => { that.apply_check_approve('delete', data) }} >{React.language('delete')}</span>
                            <span className="menu-itme passed"  >{React.language('already') + React.language('pass')}</span>
                        </>
                            : data.status == 2 ? <>
                                <span className="menu-itme delete" onClick={e => { that.apply_check_approve('delete', data) }} >{React.language('delete')}</span>
                                <span className="menu-itme refused" >{React.language('already') + React.language('refuse')}</span>
                            </>
                                : ''
                }

                </>
            }
        }]

        return <div className='approve-pane' >

            <div className='menu' >
                <span >{React.language('state') + '：'}</span>
                <BsySelect
                    allowBlank={false}
                    searchable={false}
                    minWidth={200} onStopEdit={this.get_status_value} value={status} items={items} />
            </div>

            <BsyTableList
                getValue={this.getTableValue}
                limit={limit}
                skip={skip}
                skipChange={this.skipChange}
                listLimitChange={this.listLimitChange}
                listFilterChange={this.listFilterChange}
                styleType={window.mode}
                userCont={approves}
                count={approves.count}
                list={list}
                multiple={false}
                noDarg={true}
                noMenu={true}

            // onReinvite={e => { this.againAllInvite(e) }}
            // onRowClick={(e, node) => { this.memberRowClick(e, node) }}
            />

        </div>
    }
}